export default {
  evidence: {
    client_ip: "IP truy cập",
    list: "Danh sách chứng cứ",
    new_content: "Nội dung mới",
    old_content: "Nội dung cũ",
    request_type: "Loại yêu cầu",
    time_access: "Thời gian truy cập",
    update: "Chi tiết chứng cứ",
    uri: "URI",
    user: "Người dùng",
    work_content : "Nội dung công việc",
    division: "Loại phân chia",
    connection_screen: "Màn hình liên kết",
    before: "Trước",
    after: "Sau",
    status: "Trạng thái",
    login_history_update: "Chi tiết lịch sử đăng nhập",
    sessionId: "Phiên làm việc",
    fullName: "Họ và tên"
  },
}